package com.yogaaicoach.pages.dashboard

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import io.github.aakira.napier.Napier
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch

class DashboardViewModel(private val api: DashboardApi) : ViewModel() {
    val isPageLoaded: MutableStateFlow<Boolean> = MutableStateFlow(false)

    val isReset: MutableStateFlow<Boolean> = MutableStateFlow(false)
    private var isLoading = false

    private val _isTrainingCreationInProgress = MutableStateFlow(false)
    val isTrainingCreationInProgress: StateFlow<Boolean> = _isTrainingCreationInProgress

    private val _dashboardData = MutableStateFlow<DashboardData?>(null)
    val dashboardData: StateFlow<DashboardData?> = _dashboardData

    private val _dashboardItems = MutableStateFlow<List<DashboardItem>>(listOf())
    val dashboardItems: StateFlow<List<DashboardItem>> = _dashboardItems

    private val _nextWorkout = MutableStateFlow<DashboardItem?>(null)
    val nextWorkout: StateFlow<DashboardItem?> = _nextWorkout

    // Takes a callback instead of the concrete AppViewModel (which still lives in composeApp and
    // can't be a :core dependency) — same decoupling used by the auth ViewModels' onLoginSuccess.
    fun loadPage(askNewToken: suspend () -> Unit, isReload: Boolean = false) {
        if (isLoading) return
        if (isPageLoaded.value && !isReload) {
            return
        }

        isLoading = true
        Napier.d("LoadPage: isReload: $isReload")
        isPageLoaded.value = false
        isReset.value = false

        _isTrainingCreationInProgress.value = false // Todo isn't this value always false
        viewModelScope.launch {
            _dashboardData.value = api.getDashboardData()

            if (dashboardData.value?.refreshToken == true) {
                askNewToken()
            }
            _dashboardItems.value = dashboardData.value?.dashboardItems ?: emptyList()
            setNextWorkout(dashboardItems.value)
            isPageLoaded.value = true
            isLoading = false
        }
    }

    private fun setNextWorkout(items: List<DashboardItem>) {
        _nextWorkout.value = items.firstOrNull { it.isNextWorkout }
    }

    // composeApp doesn't need this: its DashboardViewModel instance is scoped to the Navigation
    // backstack entry, so logging out and back in tears down and recreates it via Koin. jsMain
    // has no such scoping — dashboardViewModel is a single long-lived instance for the whole
    // page's lifetime — so without this, loadPage()'s isPageLoaded guard would silently no-op on
    // a new login and leave the previous user's data on screen. Call this when a new login is
    // detected, before the page that triggers loadPage() mounts.
    fun reset() {
        isLoading = false
        isPageLoaded.value = false
        isReset.value = false
        _isTrainingCreationInProgress.value = false
        _dashboardData.value = null
        _dashboardItems.value = emptyList()
        _nextWorkout.value = null
    }
}
